import styled from "styled-components";

interface TabContentStyleProps {
  $nav?: boolean;
  $padding?: boolean;
}

export const TabContent = styled.div<TabContentStyleProps>`
  width: 100vw;
  display: grid;
  grid-template-rows: 50px ${(props) =>
      props.$nav === false ? "calc(100vh - 106px)" : "calc(100vh - 176px)"};
`;

export const TabListBox = styled.div`
  width: 100vw;
`;

export const TabItemContent = styled.div<TabContentStyleProps>`
  width: 100vw;
  height: ${(props) =>
    props.$nav === false ? "calc(100vh - 106px)" : "calc(100vh - 176px)"};
  padding: ${(props) => (props.$padding === true ? "16px" : "0")};
  overflow-y: auto;
  background: ${(props) => props.theme.colors.mainBg};
`;
